import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { ComplianceNote } from "@/components/ComplianceNote";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Contatti() {
  useSeo({
    title: "Contatti",
    description:
      "Contatta Opera Real Estate Partners. Investitori, proprietari, partner tecnici: instrada la tua richiesta al dipartimento giusto. Sede in San Giuliano Terme (PI), orari e contatti diretti.",
  });

  const contactProfiles = [
    "Investitore / Family Office (Opportunità di Rendimento)",
    "Proprietario di Immobile (Valorizzazione o Cessione)",
    "Partner Tecnico / Professionista (Architetto, Legale, Agenzia)",
    "Altro / Richiesta Informazioni Generali",
  ];

  return (
    <div>
      <section className="bg-[#0D1B2A] pt-20 pb-14 border-b border-white/5 relative noise-overlay">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 relative z-10">
          <span className="label-eyebrow">Contatti</span>
          <Reveal>
            <h1 className="font-display font-light text-4xl lg:text-6xl text-white mt-4 max-w-3xl leading-tight">
              Parliamo del tuo progetto
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#1E2229] py-20">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-14">
          <div className="lg:col-span-3">
            <Reveal>
              <h2 className="font-display font-light text-2xl text-white mb-8">Scrivici</h2>
              <LeadForm
                showProfile
                sourcePage="Contatti — form generale"
                profileOptions={contactProfiles}
                messagePlaceholder="Breve descrizione della richiesta o dell'operazione"
                privacyPrefix="Dichiaro di aver letto l'"
                privacyLinkLabel="Informativa Privacy"
                privacySuffix=" e acconsento al trattamento dei miei dati per la gestione della richiesta."
              />
            </Reveal>
          </div>

          <div className="lg:col-span-2 space-y-10">
            <Reveal delay={0.1}>
              <div>
                <span className="label-eyebrow">Sede</span>
                <ul className="mt-4 space-y-4 text-gray-300">
                  <li className="flex items-start gap-3">
                    <MapPin className="text-[#C5A059] mt-0.5" size={18} strokeWidth={1.5} />
                    SS12 Abetone e Brennero KM 5+812 n. 7/C, 56017 San Giuliano Terme (PI)
                  </li>
                  <li className="flex items-center gap-3">
                    <Phone className="text-[#C5A059]" size={18} strokeWidth={1.5} />
                    <a href="tel:+393394641508" className="hover:text-[#C5A059] transition-colors">+39 339 464 1508</a>
                  </li>
                  <li className="flex items-center gap-3">
                    <Mail className="text-[#C5A059]" size={18} strokeWidth={1.5} />
                    info@operapartners.it
                  </li>
                  <li className="flex items-start gap-3">
                    <Clock className="text-[#C5A059] mt-0.5" size={18} strokeWidth={1.5} />
                    Lun–Ven, 9:00–18:30
                  </li>
                </ul>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="border border-white/10 overflow-hidden">
                <iframe
                  title="Mappa sede"
                  src="https://www.google.com/maps?q=SS12%20Abetone%20e%20Brennero%20KM%205%2B812%207%2FC%2056017%20San%20Giuliano%20Terme%20PI&output=embed"
                  className="w-full h-56 grayscale"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-5 lg:px-8 mt-14 pt-8 border-t border-white/5">
          <ComplianceNote />
        </div>
      </section>
    </div>
  );
}
